import { AppAuth } from "../util/AppAuth";

export const ErrorPage = () => {
  return (
    <>
      <p onClick={() => AppAuth.signOut()}>logout</p>
    </>
  );
};
